import apiClient from "./apiClient.js";
import {setAlert} from "./alert";
import {Dispatch} from "redux";
import {History} from "history";
import {AlertTypes} from "../utils/alert.utils";
import {errorHandler} from "../utils/error-handler.utils";


export const add = async <T>(instance: T, schemaName: string,
                             history: History, dispatch?: Dispatch<any>
) => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const body = JSON.stringify(instance);

    try {
        await apiClient.post(`/${schemaName}s`, body, config);

        dispatch && dispatch(setAlert(` The ${schemaName} has been added successfully!`, AlertTypes.SUCCESS));

        history.push(`/${schemaName}s`);
    } catch (err) {
        dispatch && errorHandler(err, dispatch);
    }
};

export const update = async <T>(_id: string, instance: T, schemaName: string, history: History, dispatch?: Dispatch<any>) => {

    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    // The request body  - stringify it for prepare the data to send to the server.
    const body = JSON.stringify({
        ...instance,
    });

    try {
        // Response from the server.
        const res = await apiClient.patch(
            `/${schemaName}s/${_id}` /**the endpoint in the server */,
            body,
            config
        );

        dispatch && dispatch(setAlert(` The ${schemaName} has been updated successfully!`, AlertTypes.SUCCESS));
        history.push(`/${schemaName}s`);
    } catch (err) {
        dispatch && errorHandler(err, dispatch);
    }
};

export const deleteInstance = async (_id: string, schemaName: string, history: History, dispatch?: Dispatch<any>) => {
    try {
        await apiClient.delete(`/${schemaName}s/${_id}`);
        dispatch && dispatch(setAlert(`The ${schemaName} removed successfully.`, AlertTypes.SUCCESS));
        history.push(`/${schemaName}s`);

    } catch (err) {
        dispatch && errorHandler(err, dispatch);
    }
};

export const getAll = <T>(route: string) => async (dispatch: Dispatch<any>): Promise<T[]> => {
    try {

        const res = await apiClient.get(route);
        const instances: T[] = res.data.results;

        return instances;
    } catch (err) {
        errorHandler(err, dispatch);
        throw new Error();
    }
};

export const getById = async (id: string, schemaName: string, dispatch: Dispatch): Promise<any> => {
    try {
        const res = await apiClient.get(`/${schemaName}s/${id}`);

        if (!res.data) {
            throw new Error(`${schemaName} not found`);
        }

        return res.data;
    } catch (err) {
        errorHandler(err, dispatch);
    }
};

export const changePassword = async (_id: string, schemaName: string, password: string): Promise<any> => {
    const config = {
        headers: {
            "Content-Type": "application/json",
        },
    };

    const body = JSON.stringify({
        password,
    });

    const res = await apiClient.patch(`/${schemaName}s/${_id}/change-password`, body, config);

    // Returns success message.
    return res.data.msg;
};



